import React from 'react';
import { i18n } from '@lt/localization';
import type { IPackageId } from './types';

import styles from './packageId.module.css';

const PackageId = ({ id, isHotelPage }: IPackageId) => (
  <div className={styles.text}>
    {isHotelPage ? i18n.t('checkout.packageInfo.packageId', { id }) : `№ ${id}`}
  </div>
);

export default PackageId;
